'use strict'
const Base = require('../base.edit')

module.exports = class testWidget extends Base {

	onInit() {

		let button = document.createElement('button')
		button.className = 'formater'
		button.innerHTML = '<i class="material-icons">settings_backup_restore</i>'
		button.onclick = () => {
			this._render(this.data)
		}
		this._elemButtons.appendChild(button)

	}

	onDestroy() {
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/test/test.edit.js
// module id = 499
// module chunks = 0